import arraySectionPrices from './arraySectionPrices';

export default function (minPrice: number, maxPrice: number, countSection: number): number[] {
    return arraySectionPrices.filter((priceSection) => (minPrice <= priceSection && priceSection <= maxPrice))
    .slice(0, countSection);
}